// extracted by mini-css-extract-plugin
export default {"navContent":"_1Mat-"};